import { Col, Flex, Form, Input, Layout, Select } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { OutcomeMeasuresHeader } from 'components/header/Header';
import { Subtitle, Title } from 'components/mvp-typography';
import { push } from 'connected-react-router';
import { PatientSubcollection } from 'lib/documents/document';
import { selectProps } from 'lib/utils/antd/select-props';
import { getPatientLinkUrl } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PatientRoutes } from 'routes';
import { useSubmitInventoryMutation } from '../injury/questionnaire-injury';

export const questions: { component: () => JSX.Element }[] = [
  {
    component: () => (
      <Form.Item
        hasFeedback
        className="form_item"
        label="Are you an athlete?"
        name="isAthlete"
        rules={[
          {
            required: true,
            message: 'This question is required'
          }
        ]}
      >
        <Select
          options={[
            {
              label: 'Yes',
              value: true
            },
            {
              label: 'No',
              value: false
            }
          ]}
          {...selectProps}
          placeholder="Choose Yes/No"
        />
      </Form.Item>
    )
  },
  {
    component: () => (
      <Form.Item
        hasFeedback
        className="form_item"
        label="If yes, what sport do you play?"
        name="sport"
        rules={[
          {
            required: false,
            message: 'This question is required'
          }
        ]}
      >
        <Input data-private="lipsum" />
      </Form.Item>
    )
  },
  {
    component: () => (
      <Form.Item
        hasFeedback
        label="Are you a student?"
        className="form_item"
        name="isStudent"
        rules={[
          {
            required: true,
            message: 'This is a required field'
          }
        ]}
      >
        <Select
          options={[
            {
              label: 'Full-time',
              value: 'full-time'
            },
            {
              label: 'Part-time',
              value: 'part-time'
            },
            {
              label: 'No',
              value: 'no'
            }
          ]}
          {...selectProps}
          placeholder="Choose Yes/No"
        />
      </Form.Item>
    )
  },
  {
    component: () => (
      <Form.Item
        hasFeedback
        label="What do you do for work?"
        className="form_item"
        name="profession"
        rules={[
          {
            required: true,
            message: 'Profession is a required field'
          }
        ]}
      >
        <Input data-private="lipsum" />
        {/* <SelectWithOther
          options={[
            {
              label: 'Department of Defense (Military)',
              value: 'department-of-defense'
            },
            {
              label: 'Emergency services (Police, Fire, Ambulance)',
              value: 'emergency-services'
            },
            {
              label: 'Construction',
              value: 'construction'
            },
            {
              label: 'Other',
              value: 'other'
            }
          ]}
          otherPlaceHolder="What is your occupation?"
          {...selectProps}
        /> */}
      </Form.Item>
    )
  },
  {
    component: () => (
      <Form.Item
        hasFeedback
        className="form_item"
        label="Have you been diagnosed with a concussion in the past?"
        name="previousConcussion"
        rules={[
          {
            required: true,
            message: 'Please select if you have previously had a concussion'
          }
        ]}
      >
        <Select
          options={[
            {
              label: 'Yes',
              value: true
            },
            {
              label: 'No',
              value: false
            }
          ]}
          {...selectProps}
          placeholder="Choose Yes/No"
        />
      </Form.Item>
    )
  }
];

interface DemographicFormType {
  sport: string;
  isAthlete: boolean;
  isStudent: boolean;
  profession: string;
  previousConcussion: boolean;
}

export function QuestionnaireDemographic() {
  const [form] = Form.useForm<DemographicFormType>();
  const { patientId } = useParams<{ patientId: string }>();
  const mut = useSubmitInventoryMutation(
    PatientSubcollection.InventoriesDemographic
  );
  const dispatch = useDispatch();

  const continueUrl = getPatientLinkUrl(
    PatientRoutes.AssessmentControlFlow,
    patientId
  );

  async function onFinish(value: DemographicFormType) {
    await mut.mutateAsync({
      data: {
        sport: value.sport,
        isAthlete: value.isAthlete,
        isStudent: value.isStudent,
        profession: value.profession,
        previousConcussion: value.previousConcussion
      }
    });
    dispatch(
      push(continueUrl, {
        fromQuestionnaire: true
      })
    );
  }
  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <OutcomeMeasuresHeader label={'Exit'} title="Who are you?" />

      <Flex align="center" vertical>
        <Col sm={24} md={12} lg={12}>
          <Form form={form} onFinish={onFinish} labelCol={{ span: 24 }}>
            <Flex gap={16} vertical>
              <div>
                <Title>Tell us a little bit about yourself</Title>
                <Subtitle>
                  We want to understand if there are specific activities that
                  might impact the assessment we give you.
                </Subtitle>
              </div>
              <div>
                {questions.map((q, i) => (
                  <q.component key={i} />
                ))}
              </div>
              <div>
                <BaseButton htmlType="submit" loading={mut.isLoading}>
                  Submit
                </BaseButton>
              </div>
            </Flex>
          </Form>

          {mut.error && <ErrorDisplay error={mut.error as any} />}
        </Col>
      </Flex>
    </Layout>
  );
}
